export async function createImageFromUrl(url: string): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.crossOrigin = "anonymous";
		img.onload = () => resolve(img);
		img.onerror = (e) => {
			reject(new Error(`Impossible de charger l'image`));
		};
		img.src = url;
	});
}

const getWatermarkSize = (size: string, wmWidth: number, wmHeight: number, canvasWidth: number, canvasHeight: number) => {
	let finalWidth: number;
	let finalHeight: number;

	if (wmWidth >= wmHeight) {
		switch (size) {
			case "medium":
				finalWidth = canvasWidth * 0.6;
				break;
			case "large":
				finalWidth = canvasWidth * 0.8;
				break;
			default:
				finalWidth = canvasWidth * 0.4;
				break;
		}
		finalHeight = (finalWidth * wmHeight) / wmWidth;
	} else {
		switch (size) {
			case "medium":
				finalHeight = canvasHeight * 0.5;
				break;
			case "large":
				finalHeight = canvasHeight * 0.7;
				break;
			default:
				finalHeight = canvasHeight * 0.3;
				break;
		}
		finalWidth = (finalHeight * wmWidth) / wmHeight;
	}

	return { width: finalWidth, height: finalHeight };
};

const getWatermarkPosition = (position: string, canvasWidth: number, canvasHeight: number, wmWidth: number, wmHeight: number) => {
	switch (position) {
		case "0":
			return { x: 0, y: 0 };
		case "1":
			return { x: (canvasWidth - wmWidth) / 2, y: 0 };
		case "2":
			return { x: canvasWidth - wmWidth, y: 0 };
		case "3":
			return { x: 0, y: (canvasHeight - wmHeight) / 2 };
		case "4":
			return { x: (canvasWidth - wmWidth) / 2, y: (canvasHeight - wmHeight) / 2 };
		case "5":
			return { x: canvasWidth - wmWidth, y: (canvasHeight - wmHeight) / 2 };
		case "6":
			return { x: 0, y: canvasHeight - wmHeight };
		case "7":
			return { x: (canvasWidth - wmWidth) / 2, y: canvasHeight - wmHeight };
		case "8":
			return { x: canvasWidth - wmWidth, y: canvasHeight - wmHeight };
		default:
			return { x: canvasWidth - wmWidth, y: canvasHeight - wmHeight };
	}
};

export async function combineImageWithStickers(photoUrl: string, stickers: any[], containerWidth: number, containerHeight: number, imageRotation: number = 0, watermark: any, method: 'camera'|'upload'): Promise<string | undefined> {
	try {
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		const baseImage = await createImageFromUrl(photoUrl) as HTMLImageElement;
		const { naturalWidth, naturalHeight } = baseImage;
		let scaleX: number, scaleY: number;

		if(method === 'upload') {
			[canvas.width, canvas.height] = (imageRotation % 180 !== 0)
				? [naturalHeight, naturalWidth]
				: [naturalWidth, naturalHeight];

			ctx.save();

			if (imageRotation !== 0) {
				ctx.translate(canvas.width / 2, canvas.height / 2);
				ctx.rotate((imageRotation * Math.PI) / 180);
			}

			switch (imageRotation) {
				case 90:
				case 270:
					ctx.drawImage(baseImage, -naturalWidth / 2, -naturalHeight / 2, canvas.height, canvas.width);
					scaleX = canvas.width / naturalHeight;
					scaleY = canvas.height / naturalWidth;
					break;
				case 180:
					ctx.drawImage(baseImage, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height);
					scaleX = canvas.width / naturalWidth;
					scaleY = canvas.height / naturalHeight;
					break;
				default:
					ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);
					scaleX = canvas.width / naturalWidth;
					scaleY = canvas.height / naturalHeight;
			}

			ctx.restore();
		} else {
			canvas.width = containerWidth;
			canvas.height = containerHeight;

			ctx.save();

			if (imageRotation !== 0) {
				ctx.translate(canvas.width / 2, canvas.height / 2);
				ctx.rotate((imageRotation * Math.PI) / 180);
				ctx.translate(-canvas.width / 2, -canvas.height / 2);
			}

			ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);

			ctx.restore();

			scaleX = canvas.width / containerWidth;
			scaleY = canvas.height / containerHeight;
		}

		if (watermark?.isUse && watermark.url) {
			try {
				const watermarkImage = await createImageFromUrl(watermark.url);

				const { width: wmWidth, height: wmHeight } = getWatermarkSize(
					watermark.size,
					watermarkImage.naturalWidth,
					watermarkImage.naturalHeight,
					canvas.width,
					canvas.height
				);

				const { x, y } = getWatermarkPosition(watermark.position, canvas.width, canvas.height, wmWidth, wmHeight);

				ctx.globalAlpha = parseFloat(watermark.opacity) / 100;
				ctx.drawImage(watermarkImage, x, y, wmWidth, wmHeight);
				ctx.globalAlpha = 1;
			} catch (error) {
				console.error("Erreur lors de l'ajout du watermark:", error);
			}
		}

		await Promise.all(stickers.map(async (sticker) => {
			try {
				console.log('sticker', sticker)
				const stickerImage = await createImageFromUrl(sticker.url);
				const scaledX = sticker.x * scaleX;
				const scaledY = sticker.y * scaleY;
				const scaledWidth = sticker.width * scaleX;
				const scaledHeight = sticker.height * scaleY;

				// ctx.drawImage(stickerImage, scaledX, scaledY, scaledWidth, scaledHeight);
				ctx.save();
				ctx.translate(scaledX + scaledWidth / 2, scaledY + scaledHeight / 2);
				ctx.rotate((sticker.rotation || 0) * Math.PI / 180);
				ctx.drawImage(stickerImage, -scaledWidth / 2, -scaledHeight / 2, scaledWidth, scaledHeight);
				ctx.restore();

			} catch (error) {
				throw new Error(`Erreur lors du traitement du sticker: ${error.message}`);
			}
		}));

		return canvas.toDataURL("image/jpeg", 0.95);
	} catch (e) {
		console.log('ERROR combineImageWithStickers : ', e);
	}
}
